import styled from '@mui/material/styles/styled';

import { excludeInvalidDOMProps } from 'utils/style';

type HeaderStyleProps = {
  $backgroundColor?: string;
};

export const Header = styled('header', {
  shouldForwardProp: excludeInvalidDOMProps,
})<HeaderStyleProps>(
  ({ theme, $backgroundColor = theme.palette.common.white }) => ({
    position: 'sticky',
    top: 0,
    zIndex: 1,
    display: 'grid',
    alignContent: 'center',
    alignItems: 'center',
    width: '100%',
    overflowX: 'auto',
    backgroundColor: $backgroundColor,
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: theme.spacing(2),
    paddingInline: theme.spacing(4),
    paddingTop: theme.spacing(2),

    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: '2fr 3fr',
      paddingInline: theme.spacing(6),
    },
  }),
);

export const Logo = styled('div')(() => ({
  justifySelf: 'start',
}));

type ContentStyleProps = {
  $secondaryBackgroundColor?: string;
};

export const Content = styled('div', {
  shouldForwardProp: excludeInvalidDOMProps,
})<ContentStyleProps>(
  ({ theme, $secondaryBackgroundColor = theme.palette.common.white }) => ({
    display: 'grid',
    alignItems: 'center',
    gridTemplate: 'auto / repeat(3, max-content)',
    gap: theme.spacing(2),
    justifyContent: 'end',

    [theme.breakpoints.up('md')]: {
      gap: theme.spacing(4),
      backgroundColor: $secondaryBackgroundColor,
      width: '100%',
    },
  }),
);
